<div class="split-s-form wg-quick-create-host">

  <div class="split-header wg-split-header">
    <div class="wg-split-tabs">
      <button class="wg-split-tab wg-split-tab--active">
        @if (headerMode === 'view') {
          <span>{{headerTitle}}</span>
        } @else if (headerTitle) {
          <span>NOV ZAPIS — {{headerTitle}}</span>
        } @else {
          <span>NOV ZAPIS</span>
        }
      </button>
    </div>

    <div class="wg-split-actions">
      @if (headerMode === 'view') {
        <button class="wg-split-action-btn" (click)="openFullPage()" title="Odpri v celotni strani">
          <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H18m0 0v4.5M18 6l-7.5 7.5M6 10.5V18h7.5"/></svg>
        </button>
      }
      <button class="wg-split-action-btn wg-split-action-btn--close" (click)="close()" title="Zapri">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
      </button>
    </div>
  </div>

  @if (iframeUrl) {
    <iframe class="wg-quick-create-iframe" [src]="iframeUrl"></iframe>
  }

</div>
